import * as React from "react";
import cn from "classnames";
import "./styles.scss";
import { IShapeColour } from "./types";
import { Shape } from "./Shape";

interface IPanelWrapperProps {
  children?: React.ReactNode;
  backgroundColour?: string;
  className?: string;
  elementsBeforeContent?: React.ReactNode;
  isBetterV2?: boolean;
  containerClassName?: string;
  backgroundSideShapes?: IShapeColour;
  hideOverflow?: boolean;
}

const Shapes: React.FC<{ colour: IShapeColour }> = ({ colour }) => (
  <div>
    <div className="panel-wrapper__background-shape--left">
      <Shape colour={colour} side="left" />
    </div>
    <div className="panel-wrapper__background-shape--right">
      <Shape colour={colour} side="right" />
    </div>
  </div>
);

export const PanelWrapper: React.FC<IPanelWrapperProps> = ({
  children,
  backgroundColour,
  className,
  elementsBeforeContent,
  isBetterV2,
  containerClassName,
  backgroundSideShapes,
  hideOverflow
}) => {
  let backgroundContent = null;

  switch (backgroundSideShapes) {
    case "purple":
      backgroundContent = <Shapes colour="purple" />;
      break;
    case "green":
      backgroundContent = <Shapes colour="green" />;
      break;
    case "orange":
      backgroundContent = <Shapes colour="orange" />;
      break;
    default:
      backgroundContent = null;
  }

  return (
    <div
      className={cn(
        "panel-wrapper",
        `panel-wrapper__bg--${backgroundColour}`,
        {
          "panel-wrapper--better-v2": isBetterV2,
          "panel-wrapper--hide-overflow": hideOverflow
        },
        containerClassName
      )}
    >
      <div className="panel-wrapper__elements-before">
        {backgroundContent}
        {elementsBeforeContent}
      </div>
      <div className={cn("panel-wrapper__content", className)}>{children}</div>
    </div>
  );
};
